module.exports = __webpack_public_path__ + "static/media/19ESCAP38.14b30da6.jpg";